import { Theme } from "@emotion/react";

export type ColorProp = keyof Theme["colors"] | (string & {});

/**
 * Converts a color string into the corresponding color from the theme if it exists.
 *
 * If the color is not found in the theme, it returns the original color string.
 */
export const getColorFromTheme = (
  color: ColorProp | undefined,
  theme: Theme,
): string | undefined => {
  if (color === undefined) {
    return undefined;
  }

  if (Object.keys(theme.colors).includes(color)) {
    return theme.colors[color as keyof typeof theme.colors];
  }

  return color;
};
